/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Lines that compare equal keep their original relative order, which is helpful when sorting by length or number.`)
};

const es_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Las líneas que se comparan igual conservan su orden relativo original, lo que es útil al ordenar por longitud o número.`)
};

const de_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Zeilen, die als gleich gelten, behalten ihre ursprüngliche relative Reihenfolge, was beim Sortieren nach Länge oder Zahl hilfreich ist.`)
};

const nl_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Regels die gelijk vergelijken behouden hun oorspronkelijke relatieve volgorde, wat nuttig is bij sorteren op lengte of aantal.`)
};

const fr_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les lignes qui se comparent égales conservent leur ordre relatif d'origine, ce qui est utile lors du tri par longueur ou par nombre.`)
};

const it_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Le righe che si confrontano in modo uguale mantengono il loro ordine relativo originale, il che è utile quando si ordina per lunghezza o numero.`)
};

const pt_br2_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. As linhas que são iguais na comparação mantêm sua ordem relativa original, o que é útil ao ordenar por comprimento ou número.`)
};

const pt_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. As linhas que se comparam como iguais mantêm sua ordem relativa original, o que é útil ao classificar por comprimento ou número.`)
};

const ja_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。同等と判定された行は元の相対的な順序を保持します。これは長さまたは数字でソートする場合に便利です。`)
};

const zh_ls_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。比较结果相同的行会保持原有的相对顺序，这在按长度或数字排序时很有用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq2_a", locale)
	if (locale === "en") return en_ls_faq2_a(inputs)
	if (locale === "es") return es_ls_faq2_a(inputs)
	if (locale === "de") return de_ls_faq2_a(inputs)
	if (locale === "nl") return nl_ls_faq2_a(inputs)
	if (locale === "fr") return fr_ls_faq2_a(inputs)
	if (locale === "it") return it_ls_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq2_a(inputs)
	if (locale === "pt") return pt_ls_faq2_a(inputs)
	if (locale === "ja") return ja_ls_faq2_a(inputs)
	return zh_ls_faq2_a(inputs)
};